import { render, staticRenderFns } from "./PasswordChanged.vue?vue&type=template&id=c3ee85ce&scoped=true"
import script from "./PasswordChanged.vue?vue&type=script&lang=js"
export * from "./PasswordChanged.vue?vue&type=script&lang=js"
import style0 from "./PasswordChanged.vue?vue&type=style&index=0&id=c3ee85ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ee85ce",
  null
  
)

export default component.exports